/**
 * The Verbleif loader: the red dot of the logo arcs over the wordmark, hops along three stops and lands back in the
 * logo. Every loop starts and ends on the plain logo, so the loader can disappear at any moment.
 *
 * Plain strings on purpose: `bootLoaderVitePlugin.ts` puts the loader in `index.html`, so it is on screen before any
 * JavaScript runs. The app hides and shows it with the `app-ready` class (`useBootLoader`). On login steps it shows the
 * login loader in the login layout instead (AUTH_LOADER_SVG, BOOT_LOGIN_LAYOUT_CSS), which AuthLoader.vue takes over.
 */

/** One loop: the dot leaves the logo and lands back in it. */
export const BRAND_LOADER_LOOP_MS = 2800;

export const BRAND_LOADER_SVG = "<svg viewBox=\"-12 -48 259 162\" aria-hidden=\"true\" focusable=\"false\"><path class=\"vb-brand-loader__route\" d=\"M13.2 97.4H221.8\" fill=\"none\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-dasharray=\"0.1 8.7\"/><path class=\"vb-brand-loader__progress\" d=\"M47.9 97.4H187.1\" fill=\"none\" stroke=\"#4caf50\" stroke-width=\"3.5\" stroke-linecap=\"round\"/><circle class=\"vb-brand-loader__stop\" cx=\"47.9\" cy=\"97.4\" r=\"6\" stroke=\"#4caf50\" stroke-width=\"2.6\"/><g class=\"vb-brand-loader__check vb-brand-loader__check--0\"><circle cx=\"47.9\" cy=\"97.4\" r=\"8.7\" fill=\"#4caf50\"/><path d=\"M44.0 97.4l2.8 2.8 5.2-5.7\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"2.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g><circle class=\"vb-brand-loader__stop\" cx=\"117.5\" cy=\"97.4\" r=\"6\" stroke=\"#4caf50\" stroke-width=\"2.6\"/><g class=\"vb-brand-loader__check vb-brand-loader__check--1\"><circle cx=\"117.5\" cy=\"97.4\" r=\"8.7\" fill=\"#4caf50\"/><path d=\"M113.6 97.4l2.8 2.8 5.2-5.7\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"2.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g><circle class=\"vb-brand-loader__stop\" cx=\"187.1\" cy=\"97.4\" r=\"6\" stroke=\"#4caf50\" stroke-width=\"2.6\"/><g class=\"vb-brand-loader__check vb-brand-loader__check--2\"><circle cx=\"187.1\" cy=\"97.4\" r=\"8.7\" fill=\"#4caf50\"/><path d=\"M183.2 97.4l2.8 2.8 5.2-5.7\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"2.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g><g fill=\"#4caf50\"><polygon points=\"20.406229 36.3819718 30.427145 3.07267606 40.5695267 3.07267606 25.1737557 47.3543662 15.6589466 47.3543662 0.327282443 3.07267606 10.4494198 3.07267606\"/><path d=\"M59.2752366,47.9729577 C54.4570992,47.9729577 50.5342087,46.4923944 47.5065649,43.5312676 C44.4789211,40.5701408 42.9662239,36.6264789 42.9684733,31.7002817 L42.9684733,30.8484507 C42.9154561,27.7847317 43.5702011,24.7502164 44.8815573,21.9819718 C46.0582061,19.4845704 47.9428186,17.3895601 50.3002748,15.9583099 C52.722023,14.5269894 55.4921934,13.7957262 58.3035115,13.8456338 C62.8022392,13.8456338 66.3393639,15.2642254 68.9148855,18.1014085 C71.4904071,20.9385915 72.781542,24.9690141 72.7882901,30.1926761 L72.7882901,33.7825352 L51.8692061,33.7825352 C52.152626,35.9323944 53.0073842,37.656338 54.4334809,38.9543662 C55.8595776,40.2523944 57.6680662,40.8957746 59.8589466,40.884507 C63.2329924,40.884507 65.8748702,39.6574648 67.7845802,37.2033803 L72.0966107,42.0405634 C70.7331329,43.9504789 68.8859185,45.4615531 66.745374,46.4180282 C64.3993258,47.4790435 61.8489861,48.0099037 59.2752366,47.9729577 Z M58.2630229,20.9307042 C56.6592568,20.872398 55.1105066,21.5209621 54.0252214,22.7053521 C52.9432774,23.8861972 52.2504733,25.576338 51.9468092,27.7757746 L64.1541069,27.7757746 L64.1541069,27.0726761 C64.1136183,25.1188732 63.5872672,23.6067606 62.5750534,22.536338 C61.5628397,21.4659155 60.1288702,20.9295775 58.273145,20.9273239 Z\"/><path d=\"M96.2277863,22.691831 C95.181633,22.540658 94.1266029,22.4593518 93.0696794,22.4484507 C89.7496183,22.4484507 87.5733588,23.5752113 86.5409008,25.8287324 L86.5409008,47.364507 L77.7683817,47.364507 L77.7683817,14.4507042 L86.0584122,14.4507042 L86.2979695,18.371831 C88.0592214,15.3543662 90.4986565,13.844507 93.6162748,13.8420091 C94.5419455,13.8354981 95.4633267,13.9688325 96.3492519,14.2377465 L96.2277863,22.691831 Z\"/><path d=\"M130.055969,31.2067606 C130.055969,36.48 128.931288,40.5926761 126.681924,43.5447887 C124.43256,46.4969014 121.294697,47.971831 117.268336,47.96958 C113.705344,47.96958 110.861023,46.6005634 108.735374,43.8625352 L108.343985,47.364507 L100.448718,47.364507 L100.448718,0.638873239 L109.221237,0.638873239 L109.221237,17.3983099 C111.245664,15.0298592 113.907786,13.844507 117.207603,13.8422535 C121.215969,13.8422535 124.358331,15.3171831 126.634687,18.2670423 C128.911043,21.2169014 130.050346,25.3690141 130.052595,30.7233803 L130.055969,31.2067606 Z M121.28345,30.5678873 C121.28345,27.2416901 120.757099,24.8135211 119.704397,23.2833803 C118.651695,21.7532394 117.082763,20.9870423 114.997603,20.9847887 C112.203893,20.9847887 110.280687,22.1307042 109.227985,24.4225352 L109.227985,37.4129577 C110.300931,39.7250704 112.244382,40.8811268 115.058336,40.8811268 C117.87229,40.8811268 119.734763,39.4816901 120.645756,36.6828169 C121.059639,35.3464789 121.26658,33.3092958 121.26658,30.5712676 Z\"/><polygon points=\"144.722947 47.364507 135.916687 47.364507 135.916687 0.638873239 144.722947 0.638873239\"/><path d=\"M167.069252,47.9729577 C162.251115,47.9729577 158.329349,46.4923944 155.303954,43.5312676 C152.27856,40.5701408 150.764738,36.6264789 150.762489,31.7002817 L150.762489,30.8484507 C150.709471,27.7847317 151.364216,24.7502164 152.675573,21.9819718 C153.854635,19.4851149 155.740113,17.3904464 158.097664,15.9583099 C160.518157,14.5269363 163.287264,13.7956453 166.097527,13.8456338 C170.596254,13.8456338 174.134504,15.2642254 176.712275,18.1014085 C179.290046,20.9385915 180.580056,24.9690141 180.582305,30.1926761 L180.582305,33.7825352 L159.663221,33.7825352 C159.861975,35.7621927 160.774961,37.6011551 162.23087,38.9543662 C163.659216,40.2523944 165.465455,40.9014085 167.649588,40.9014085 C171.023634,40.9014085 173.665511,39.6743662 175.575221,37.2202817 L179.887252,42.0574648 C178.522482,43.9607005 176.676685,45.4657348 174.539389,46.4180282 C172.193341,47.4790435 169.643001,48.0099037 167.069252,47.9729577 Z M166.057038,20.9307042 C164.454267,20.8724792 162.906584,21.521113 161.822611,22.7053521 C160.738417,23.8861972 160.044489,25.576338 159.740824,27.7757746 L171.948122,27.7757746 L171.948122,27.0726761 C171.907634,25.1188732 171.381282,23.6067606 170.369069,22.536338 C169.356855,21.4659155 167.922885,20.9295775 166.06716,20.9273239 Z\"/><path d=\"M185.501664,5.93239437 C185.463419,4.70879947 185.943937,3.52616105 186.82429,2.6771831 C187.703791,1.82535211 188.902702,1.39943662 190.421023,1.39943662 C191.939344,1.39943662 193.133756,1.82535211 194.00426,2.6771831 C195.791835,4.49242431 195.784305,7.41206633 193.987389,9.21802817 C193.087644,10.0698592 191.898855,10.4957746 190.421023,10.4957746 C188.943191,10.4957746 187.754402,10.075493 186.854656,9.23492958 C185.948015,8.38201392 185.454544,7.17749549 185.501664,5.93239437 Z M194.820779,47.364507 L186.014519,47.364507 L186.014519,14.4507042 L194.820779,14.4507042 Z\"/><path d=\"M204.450305,47.364507 L204.450305,20.8969014 L199.561313,20.8969014 L199.561313,14.4507042 L204.450305,14.4507042 L204.450305,11.651831 C204.450305,7.96056338 205.507506,5.09521127 207.621908,3.05577465 C209.73631,1.01633803 212.697598,0.00225352113 216.505771,0.0134282619 C218.011509,0.0515447853 219.508487,0.255591735 220.969634,0.621971831 L220.878534,7.43661972 C220.001963,7.23836244 219.104773,7.14643485 218.20629,7.1628169 C214.906473,7.1628169 213.256565,8.7143662 213.256565,11.8174648 L213.256565,14.4642254 L219.788718,14.4642254 L219.788718,20.8969014 L213.256565,20.8969014 L213.256565,47.364507 Z\"/></g><g class=\"vb-brand-loader__dot\"><circle class=\"vb-brand-loader__squash\" cx=\"230.0\" cy=\"42.5\" r=\"5\" fill=\"#f44336\"/></g></svg>";

export const BRAND_LOADER_CSS = `
.vb-loader-screen {
  position: fixed;
  inset: 0;
  z-index: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 0 16px;
  background: #ffffff;
}
.dark .vb-loader-screen {
  background: #42484d;
}
.app-ready .vb-loader-screen {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0s linear 0.3s;
}
.vb-loader-screen__message {
  min-height: 96px;
  max-width: 384px;
  text-align: center;
  font-family: Roboto, system-ui, sans-serif;
  animation: vb-loader-message-in 0.5s ease;
}
.vb-loader-screen__message:empty {
  animation: none;
}
.vb-loader-screen__title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  color: #424242;
}
.vb-loader-screen__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #616161;
}
.vb-loader-screen__text a {
  font-weight: 700;
  color: #2e7d32;
  text-decoration: underline;
}
.dark .vb-loader-screen__title {
  color: #f4f5f7;
}
.dark .vb-loader-screen__text {
  color: #ccd2d5;
}
.dark .vb-loader-screen__text a {
  color: #81c784;
}
@keyframes vb-loader-message-in {
  from { opacity: 0; }
}
.vb-brand-loader {
  display: block;
  width: 260px;
  max-width: 70vw;
}
.vb-brand-loader svg {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}
.vb-brand-loader__route {
  stroke: #c8e6c9;
}
.vb-brand-loader__stop {
  fill: #ffffff;
}
.dark .vb-brand-loader__route {
  stroke: #2e7d32;
}
.dark .vb-brand-loader__stop {
  fill: #42484d;
}
.vb-brand-loader__dot, .vb-brand-loader__squash, .vb-brand-loader__progress, .vb-brand-loader__check {
  animation-duration: var(--vb-brand-loader-loop);
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.vb-brand-loader {
  --vb-brand-loader-loop: ${BRAND_LOADER_LOOP_MS}ms;
}
.vb-brand-loader__dot {
  animation-name: vb-brand-loader-dot;
}
.vb-brand-loader__squash {
  animation-name: vb-brand-loader-squash;
  transform-box: fill-box;
  transform-origin: 50% 100%;
}
.vb-brand-loader__progress {
  stroke-dasharray: 139.2 139.2;
  animation-name: vb-brand-loader-progress;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.vb-brand-loader__check {
  transform: scale(0);
  transform-box: fill-box;
  transform-origin: center;
}
.vb-brand-loader__check--0 {
  animation-name: vb-brand-loader-check-0;
}
.vb-brand-loader__check--1 {
  animation-name: vb-brand-loader-check-1;
}
.vb-brand-loader__check--2 {
  animation-name: vb-brand-loader-check-2;
}
@media (prefers-reduced-motion: reduce) {
  .vb-brand-loader__dot, .vb-brand-loader__squash, .vb-brand-loader__progress, .vb-brand-loader__check {
    animation: none;
  }
  .vb-brand-loader__progress {
    stroke-dashoffset: 139.2;
  }
}
@keyframes vb-brand-loader-dot {
  0% { transform: translate(0.0px, 0.0px); }
  4% { transform: translate(0.0px, 0.0px); }
  6% { transform: translate(-15.2px, -27.2px); }
  8% { transform: translate(-30.3px, -48.6px); }
  10% { transform: translate(-45.5px, -64.3px); }
  12% { transform: translate(-60.7px, -74.1px); }
  14% { transform: translate(-75.9px, -78.2px); }
  16% { transform: translate(-91.1px, -76.5px); }
  18% { transform: translate(-106.2px, -69.1px); }
  20% { transform: translate(-121.4px, -55.8px); }
  22% { transform: translate(-136.6px, -36.8px); }
  24% { transform: translate(-151.8px, -12.0px); }
  26% { transform: translate(-166.9px, 18.5px); }
  28% { transform: translate(-182.1px, 54.9px); }
  32% { transform: translate(-182.1px, 54.9px); }
  33% { transform: translate(-176.3px, 47.0px); }
  34% { transform: translate(-170.5px, 40.5px); }
  35% { transform: translate(-164.7px, 35.4px); }
  36% { transform: translate(-158.9px, 31.8px); }
  37% { transform: translate(-153.1px, 29.6px); }
  38% { transform: translate(-147.3px, 28.9px); }
  39% { transform: translate(-141.5px, 29.6px); }
  40% { transform: translate(-135.7px, 31.8px); }
  41% { transform: translate(-129.9px, 35.4px); }
  42% { transform: translate(-124.1px, 40.5px); }
  43% { transform: translate(-118.3px, 47.0px); }
  44% { transform: translate(-112.5px, 54.9px); }
  48% { transform: translate(-112.5px, 54.9px); }
  49% { transform: translate(-106.7px, 47.0px); }
  50% { transform: translate(-100.9px, 40.5px); }
  51% { transform: translate(-95.1px, 35.4px); }
  52% { transform: translate(-89.3px, 31.8px); }
  53% { transform: translate(-83.5px, 29.6px); }
  54% { transform: translate(-77.7px, 28.9px); }
  55% { transform: translate(-71.9px, 29.6px); }
  56% { transform: translate(-66.1px, 31.8px); }
  57% { transform: translate(-60.3px, 35.4px); }
  58% { transform: translate(-54.5px, 40.5px); }
  59% { transform: translate(-48.7px, 47.0px); }
  60% { transform: translate(-42.9px, 54.9px); }
  64% { transform: translate(-42.9px, 54.9px); }
  65.33% { transform: translate(-39.3px, 31.7px); }
  66.67% { transform: translate(-35.8px, 11.9px); }
  68% { transform: translate(-32.2px, -4.6px); }
  69.33% { transform: translate(-28.6px, -17.6px); }
  70.67% { transform: translate(-25.0px, -27.3px); }
  72% { transform: translate(-21.4px, -33.5px); }
  73.33% { transform: translate(-17.9px, -36.4px); }
  74.67% { transform: translate(-14.3px, -35.9px); }
  76% { transform: translate(-10.7px, -32.0px); }
  77.33% { transform: translate(-7.2px, -24.7px); }
  78.67% { transform: translate(-3.6px, -14.1px); }
  80% { transform: translate(0.0px, 0.0px); }
  100% { transform: translate(0.0px, 0.0px); }
}
@keyframes vb-brand-loader-squash {
  0% { transform: scale(1, 1); }
  4% { transform: scale(1.3, 0.72); }
  5.5% { transform: scale(0.9, 1.15); }
  8% { transform: scale(1, 1); }
  27.6% { transform: scale(1, 1); }
  29% { transform: scale(1.4, 0.64); }
  30.6% { transform: scale(0.92, 1.1); }
  31.6% { transform: scale(1, 1); }
  32% { transform: scale(1.3, 0.72); }
  33.5% { transform: scale(0.9, 1.15); }
  36% { transform: scale(1, 1); }
  43.6% { transform: scale(1, 1); }
  45% { transform: scale(1.4, 0.64); }
  46.6% { transform: scale(0.92, 1.1); }
  47.6% { transform: scale(1, 1); }
  48% { transform: scale(1.3, 0.72); }
  49.5% { transform: scale(0.9, 1.15); }
  52% { transform: scale(1, 1); }
  59.6% { transform: scale(1, 1); }
  61% { transform: scale(1.4, 0.64); }
  62.6% { transform: scale(0.92, 1.1); }
  63.6% { transform: scale(1, 1); }
  64% { transform: scale(1.3, 0.72); }
  65.5% { transform: scale(0.9, 1.15); }
  68% { transform: scale(1, 1); }
  79.6% { transform: scale(1, 1); }
  81% { transform: scale(1.4, 0.64); }
  82.6% { transform: scale(0.92, 1.1); }
  83.6% { transform: scale(1, 1); }
  100% { transform: scale(1, 1); }
}
@keyframes vb-brand-loader-progress {
  0%, 32% { stroke-dashoffset: 139.2; opacity: 1; }
  44%, 48% { stroke-dashoffset: 69.6; }
  60%, 92% { stroke-dashoffset: 0; opacity: 1; }
  99% { stroke-dashoffset: 0; opacity: 0; }
  100% { stroke-dashoffset: 139.2; opacity: 0; }
}
@keyframes vb-brand-loader-check-0 {
  0%, 32% { transform: scale(0); }
  35% { transform: scale(1.3); }
  37%, 92% { transform: scale(1); opacity: 1; }
  99% { transform: scale(1); opacity: 0; }
  100% { transform: scale(0); opacity: 0; }
}
@keyframes vb-brand-loader-check-1 {
  0%, 48% { transform: scale(0); }
  51% { transform: scale(1.3); }
  53%, 92% { transform: scale(1); opacity: 1; }
  99% { transform: scale(1); opacity: 0; }
  100% { transform: scale(0); opacity: 0; }
}
@keyframes vb-brand-loader-check-2 {
  0%, 64% { transform: scale(0); }
  67% { transform: scale(1.3); }
  69%, 92% { transform: scale(1); opacity: 1; }
  99% { transform: scale(1); opacity: 0; }
  100% { transform: scale(0); opacity: 0; }
}
`;

/** The word mark of the boot loader, without its route, dot and check marks. */
const WORDMARK = (() => {
  const start = BRAND_LOADER_SVG.indexOf("<g fill=\"#4caf50\">");
  const end = BRAND_LOADER_SVG.indexOf("<g class=\"vb-brand-loader__dot\">");
  if (start === -1 || end === -1) {
    throw new Error("brandLoader: the BrandLoader markup changed, the word mark could not be found");
  }

  return BRAND_LOADER_SVG.slice(start, end);
})();

const AUTH_LOADER_STOPS = [47.9, 117.5, 187.1];

/**
 * The login loader: the word mark of the boot loader with a route that draws itself, three stops and the dot. Used
 * by AuthLoader.vue and by the login layout of the loader in index.html, so both draw exactly the same; the
 * animation is in `authLoader.css`.
 */
export const AUTH_LOADER_SVG = [
  "<svg viewBox=\"-12 -48 259 162\" focusable=\"false\">",
  "<path class=\"auth-loader__route\" d=\"M13.2 97.4H221.8\" fill=\"none\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-dasharray=\"0.1 8.7\"/>",
  "<path class=\"auth-loader__progress auth-loader__progress--0\" d=\"M47.9 97.4H117.5\" fill=\"none\" stroke=\"#4caf50\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>",
  "<path class=\"auth-loader__progress auth-loader__progress--1\" d=\"M117.5 97.4H187.1\" fill=\"none\" stroke=\"#4caf50\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>",
  ...AUTH_LOADER_STOPS.map((x, index) => [
    `<circle class="auth-loader__stop auth-loader__stop--${index}" cx="${x}" cy="97.4" r="6" stroke="#4caf50" stroke-width="2.6"/>`,
    `<g class="auth-loader__check auth-loader__check--${index}"><circle cx="${x}" cy="97.4" r="8.7" fill="#4caf50"/>`,
    `<path d="M${(x - 3.9).toFixed(1)} 97.4l2.8 2.8 5.2-5.7" fill="none" stroke="#ffffff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></g>`,
  ].join("")),
  WORDMARK,
  "<g class=\"auth-loader__dot\"><circle class=\"auth-loader__squash\" cx=\"230\" cy=\"42.5\" r=\"5\" fill=\"#f44336\"/></g>",
  "</svg>",
].join("");

/**
 * The login layout of the loader in index.html: the same columns as AuthContainer.vue (controls row, a 400px column,
 * footer, website panel from 768px), so the login loader sits on the spot where the page's own AuthLoader takes over.
 * The controls, footer texts and the website itself come with the app; the panel shows its green until then, like the
 * iframe does. bootLoaderScript.ts switches it on with the `vb-boot-login` class on <html>.
 */
export const BOOT_LOGIN_LAYOUT_CSS = `
.vb-loader-login {
  display: none;
}
.vb-boot-login .vb-loader-screen {
  display: block;
  padding: 0;
}
.vb-boot-login .vb-loader-screen > .vb-brand-loader,
.vb-boot-login .vb-loader-screen > .vb-loader-screen__message {
  display: none;
}
.vb-boot-login.dark .vb-loader-screen {
  background: #383c41;
}
.vb-boot-login .vb-loader-login {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}
.vb-loader-login__column {
  position: relative;
  display: flex;
  flex: 1 1 0%;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  padding: 16px 16px 0;
}
.vb-loader-login__controls {
  width: 100%;
  min-height: 40px;
}
.vb-loader-login__main {
  display: flex;
  width: 100%;
  max-width: 400px;
  flex: 1 1 0%;
  flex-direction: column;
  padding-top: 16px;
}
.vb-loader-login__footer {
  flex: none;
  width: 100%;
  height: 76px;
}
.vb-loader-login__panel {
  display: none;
  flex: 1 1 0%;
  background: #4caf58;
}
@media (min-width: 640px) {
  .vb-loader-login__column {
    padding: 20px 24px 0;
  }
  .vb-loader-login__main {
    padding-top: 36px;
  }
  .vb-loader-login__footer {
    height: 52px;
  }
}
@media (min-width: 768px) {
  .vb-boot-login .vb-loader-login {
    flex-direction: row;
  }
  .vb-loader-login__panel {
    display: block;
  }
}
/* The page before showed the login loader: start it with the entry done (AUTH_LOADER_ENTRY_MS), logo in the middle. */
.vb-boot-login-continue .vb-loader-login .auth-loader {
  --auth-loader-offset: -1300ms;
}
.vb-boot-login-still .vb-loader-login .auth-loader__stage {
  animation: none;
  transform: none;
}
.vb-boot-login-still .vb-loader-login .auth-loader__route,
.vb-boot-login-still .vb-loader-login .auth-loader__stop {
  animation: none;
  visibility: hidden;
}
.vb-boot-login-still .vb-loader-login .auth-loader__dot,
.vb-boot-login-still .vb-loader-login .auth-loader__squash,
.vb-boot-login-still .vb-loader-login .auth-loader__progress,
.vb-boot-login-still .vb-loader-login .auth-loader__check {
  animation: none;
}
`;

/**
 * The `<head>` part of the boot loader: its styles and the same-origin script (`bootLoaderScript.ts`).
 * `authLoaderCss` is the content of `authLoader.css`, read by the Vite plugin.
 */
export function bootLoaderHead(scriptSrc: string, authLoaderCss: string): string {
  return `<style>${BRAND_LOADER_CSS}${authLoaderCss}${BOOT_LOGIN_LAYOUT_CSS}</style><script src="${scriptSrc}"></script>`;
}

/**
 * The `<body>` part of the boot loader: the full screen loader and its login layout; the script picks one and gives
 * it a translated label and, when slow, the message.
 */
export function bootLoaderBody(): string {
  const login = "<div class=\"vb-loader-login\">"
    + "<div class=\"vb-loader-login__column\"><div class=\"vb-loader-login__controls\"></div>"
    + "<div class=\"vb-loader-login__main\"><div class=\"auth-loader\">"
    + `<div class="auth-loader__stage" aria-hidden="true">${AUTH_LOADER_SVG}</div>`
    + "<div class=\"auth-loader__slow\" aria-live=\"polite\"></div>"
    + "</div></div><div class=\"vb-loader-login__footer\"></div></div>"
    + "<div class=\"vb-loader-login__panel\"></div>"
    + "</div>";

  return `<div class="vb-loader-screen" role="status" aria-busy="true" aria-label="Verbleif"><div class="vb-brand-loader">${BRAND_LOADER_SVG}</div><div class="vb-loader-screen__message" aria-live="polite"></div>${login}</div>`;
}
